import { createFileRoute } from "@tanstack/react-router";

import TvDashboard from "../pages/TvDashboard";
import { RequireAuth } from "../utils/RequireAuth";

// Deliberately outside the `_shell` layout: no sidebar, no topbar, no page
// chrome. This is the URL an office TV is pointed at, so it owns the viewport.
// Not in the navigation either — admins reach it by typing /tv.
export const Route = createFileRoute("/tv")({
  component: TvRoute,
});

function TvRoute() {
  return (
    <RequireAuth require="admin">
      <TvDashboard />
    </RequireAuth>
  );
}
